import { render, staticRenderFns } from "./expressHandoverScanning.vue?vue&type=template&id=5c708892&scoped=true"
import script from "./expressHandoverScanning.vue?vue&type=script&lang=js"
export * from "./expressHandoverScanning.vue?vue&type=script&lang=js"
import style0 from "./expressHandoverScanning.vue?vue&type=style&index=0&id=5c708892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c708892",
  null
  
)

export default component.exports